import 'Components/atoms/vm-icon/vm-icon';
import { html, LitElement } from 'lit';
import { isDesktop } from 'Utils/viewport';
import Styles from './vm-slider.scss';

export default class VmSlider extends LitElement {
    static styles = Styles;

    static properties = {
        activeIndex: { type: Number },
        _prevDisabled: { type: Boolean, state: true },
        _nextDisabled: { type: Boolean, state: true },
    };

    constructor() {
        super();
        this.activeIndex = 0;
        this._prevDisabled = true;
        this._nextDisabled = false;
    }

    firstUpdated() {
        this._sliderContent = this.renderRoot.querySelector('.vm-slider__content');
        this.handleScroll();
    }

    updated(changedProperties) {
        if (changedProperties.has('activeIndex') && this._sliderContent) {
            this.scrollToIndex(this.activeIndex);
        }
    }

    scrollToIndex(index) {
        const items = this._sliderContent?.querySelector('slot')?.assignedElements({ flatten: true }) || [];
        const item = items[index];

        if (item) {
            item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: isDesktop() ? 'center' : 'start' });
        }
    }

    handleScroll() {
        const scrollWidth = this._sliderContent.scrollWidth;
        const outerWidth = this._sliderContent.clientWidth;
        const scrollLeft = this._sliderContent.scrollLeft;

        this._prevDisabled = scrollLeft <= 0;
        this._nextDisabled = scrollLeft >= scrollWidth - outerWidth;
    }

    getOverlap() {
        const items = this._sliderContent?.querySelector('slot')?.assignedElements({ flatten: true }) || [];
        const firstItem = items[0];
        return firstItem ? firstItem.offsetWidth + 16 : 0;
    }

    handleNextClick() {
        this._sliderContent?.scrollBy({
            left: this._sliderContent.clientWidth - this.getOverlap(),
            behavior: 'smooth',
        });
    }

    handlePrevClick() {
        this._sliderContent?.scrollBy({
            left: -(this._sliderContent.clientWidth - this.getOverlap()),
            behavior: 'smooth',
        });
    }

    render() {
        return html`
            <div
                class="vm-slider__content ${this._prevDisabled
                    ? 'vm-slider__content--prev-disabled'
                    : 'vm-slider__content--prev-enabled'} ${this._nextDisabled
                    ? 'vm-slider__content--next-disabled'
                    : 'vm-slider__content--next-enabled'}"
                role="list"
                @scroll=${this.handleScroll}
            >
                <slot></slot>
            </div>
            <vm-button
                class="vm-slider__control vm-slider__control--prev"
                ?hidden=${this._prevDisabled}
                variant="secondary"
                size="md"
                custom="icon-only"
                aria-label="Previous slide"
                @click=${this.handlePrevClick}
            >
                <vm-icon name="chevron-left"></vm-icon>
            </vm-button>
            <vm-button
                class="vm-slider__control vm-slider__control--next"
                ?hidden=${this._nextDisabled}
                variant="secondary"
                size="md"
                custom="icon-only"
                aria-label="Next slide"
                @click=${this.handleNextClick}
            >
                <vm-icon name="chevron-right"></vm-icon>
            </vm-button>
        `;
    }
}

customElements.define('vm-slider', VmSlider);
